import React, { useEffect, useState } from 'react'
import { useUpdateOnboardWorkshopDataMutation } from '../../../Services/vehicle/Vehicle'
import useThemeColors from '../ThemeColors'
import { toast } from 'react-toastify'
import { Loader } from 'react-bootstrap-typeahead'


interface IPROPS {
    storedWorkshopData:any
    closeModal:any
    refetch:any
}

const InactiveWorkshopModal: React.FC<IPROPS> = ({storedWorkshopData, closeModal, refetch}) => {
  const [loader, setLoader] = useState(false)

    const [updateWorkshopTrigger, {status}] = useUpdateOnboardWorkshopDataMutation()

    useEffect(() => {
      if (status === "pending") {
        setLoader(true)

      }
      else {
        setLoader(false)
      }

    }, [status])



    const activateWorkshophandler = async() => {
        const payload = {
            is_active: false

        }

        const response = await updateWorkshopTrigger({id: storedWorkshopData?.id, body: payload})

        if (response?.data) {
          closeModal()
          toast.success("Workshop inactivated successfully")
          refetch()

        }
           else if (response?.error) {
                  toast.error("An error occured")
        
                }

    }

        const {
            selectedColor,
            selectedBackgroundColor,
            selectedBorderColor,
            selectedButtonBackgoundColors,
            selectedButtonColors,
        } = useThemeColors();


  return (
        <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <i
          style={{
            fontSize: "26px",
            color: "black",
            cursor: "pointer",
          }}
          className="bi bi-x"
          onClick={closeModal}
        ></i>
      </div>
      <div style={{ color: "#3071e4", fontSize: "18px" }}>Are you sure?</div>
      <div style={{ marginBottom: "15px", fontSize: "16px" }}>
        Do you really want to  <span style={{ color: "#f1416c"}}>Inactivate</span> this workshop?
      </div>
      <div style={{ display: "flex", gap: "10px", width: "100%", justifyContent: "end" }}>
        <button onClick={activateWorkshophandler}   style={{
                            padding: "10px 25px",
                            borderRadius: "20px",
                            background: `${selectedButtonBackgoundColors}`,
                            color: `${selectedButtonColors}`,
                            border: `1px solid ${selectedBorderColor}`,
                        }}
                        >
                          {loader ? <>Saving...<Loader /></> : "Save"}
        </button>
        <button className="btn btn-light" onClick={closeModal} >
          Cancel
        </button>
      </div>
    </div>
  )
}

export default InactiveWorkshopModal


